import Direction2D from './Direction2D';
import Line2D from './Line2D';
import Point2D from './Point2D';
import { distanceGreaterThan, distanceLessThan } from './units';

// The set of all points on one side of a line. It is left unspecified whether the boundary line is included;
// method names should distinguish whether that is the case for those methods where it makes a difference.
class HalfPlane2D {
  // The direction from the half-plane's exterior to the half-plane's interior, perpendicular to the boundary line.
  readonly direction: Direction2D;
  // The distance from the origin to the half-plane's boundary line, or the negative of that if the origin is interior
  // to the half-line.
  readonly offsetFromOrigin: number;

  private constructor(direction: Direction2D, offsetFromOrigin: number) {
    this.direction = direction;
    this.offsetFromOrigin = offsetFromOrigin;
  }

  static fromDirectionAndBoundaryPoint(direction: Direction2D, point: Point2D) {
    return new HalfPlane2D(direction, direction.toVector(1).dotProduct(point.vectorFromOrigin));
  }

  get boundary() {
    return new Line2D(this.direction.toVector(this.offsetFromOrigin).imageOfOrigin, this.direction.rotateQuarterTurn());
  }

  signedDistanceTo(point: Point2D) {
    return point.vectorFromOrigin.dotProduct(this.direction.toVector(1)) - this.offsetFromOrigin;
  }

  containsPointOnInside(point: Point2D) {
    return distanceGreaterThan(this.signedDistanceTo(point), 0);
  }

  containsPointOnOutside(point: Point2D) {
    return distanceLessThan(this.signedDistanceTo(point), 0);
  }
}

export default HalfPlane2D;
